import Mask from '../../../components/Mask';
import { inject, observer } from 'mobx-react';
import defaultAvatar from '@/assets/images/simulation/default_avatar.webp';
import styles from './RoleIntroduceModal.module.scss';
import { Popup } from 'antd-mobile';
import MyIcon from '@/components/MyIcon';
const RoleIntroduceModal = (props) => {
    const { onClose, show } = props;
    let { simulation } = props.store;
    let { character = { other_roles: [] }, goal, rules } = simulation;
    return (
        <>
            <Popup
                showCloseButton={false}
                bodyStyle={{
                    borderTopLeftRadius: '16px',
                    borderTopRightRadius: '16px',
                    overflow: 'hidden'
                }}
                onMaskClick={onClose}
                visible={show}
                show={show}
            >
                <div className={styles.modalWrap}>
                    <div className={styles.title}>
                        {/* 占位用，保持title居中 */}
                        <span className={styles.closeIcon} style={{ visibility: 'hidden' }}>
                            <MyIcon type="icon-a-guanbi31" />
                        </span>
                        <span className={styles.roleText}> 角色回顾</span>
                        <span onClick={onClose} className={styles.closeIcon}>
                            <MyIcon type="icon-a-guanbi31" />
                        </span>
                    </div>
                    <div className={styles.container}>
                        {/* 角色信息区域 */}
                        <div className={styles.roleInfoSection}>
                            <div className={styles.avatarContainer}>
                                <div className={styles.avatar}>
                                    {/* 实际项目中替换为真实头像 */}
                                    <img src={character.avatar || defaultAvatar} alt={character.name} />
                                </div>
                                <div className={styles.roleName}>
                                    <span className={styles.roleLabel}>【你】：{character?.name}</span>
                                    <span className={styles.roleText}>{character?.role}</span>
                                </div>
                            </div>
                        </div>
                        <div className={styles.mainContent}>
                            {/* 角色卡片区域 */}

                            <div className={[`${styles.roleCardsContainer} ${styles.groupWrap}`]}>
                                <div className={styles.roleCardsTitle}>【其他角色】</div>
                                {character?.other_roles &&
                                    character?.other_roles.map((role, index) => (
                                        <div key={index} className={styles.roleCard}>
                                            <div className={styles.roleCardName}>{role.name}</div>
                                            <div className={styles.roleCardDescription}>{role.intro}</div>
                                        </div>
                                    ))}
                            </div>

                            {/* 目标区域 */}
                            <div className={[`${styles.section} ${styles.groupWrap}`]}>
                                <div className={styles.sectionTitle}>【你的目标】</div>
                                <div className={styles.sectionContent}>{goal?.description}</div>
                            </div>
                            {/* 行为约束规则区域 */}
                            <div className={[`${styles.section} ${styles.groupWrap}`]}>
                                <div className={styles.sectionTitle}>【行为约束规则】</div>
                                {rules.map((rule, index) => (
                                    <div key={index} className={[`${styles.sectionContent} ${styles.ruleItem}`]}>
                                        {rule}
                                        {/* <span className={styles.ruleDot}></span>
                                        <span className={styles.ruleText}> {rule}</span> */}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default inject('store')(observer(RoleIntroduceModal));
